// Example https://github.com/vuejs/vuex/tree/dev/examples/shopping-cart
import authService from '../../services/auth/auth.service';
import jwtService from '../../services/auth/jwt.service';
import { EventBus } from './../../main';
import router from './../../router';

const state = () => ({
  firstname: '',
  lastname: '',
  phonenumber: '',
  email: '',
  type: '',
  isAuthenticated: false,
})

const getters = {
  currentUser: (state) => {
    return {
      firstname: state.firstname,
      lastname: state.lastname,
      phonenumber: state.phonenumber,
      email: state.email,
      type: state.type,
      id: state.id // Access the ID property
    };
  },
  isAuthenticated: (state) => {
    return state.isAuthenticated;
  }
}

const actions = {
  async getUser ({ commit }) {
    try{
      const res = await authService.getAuthenticatedUser();
      commit('ChangeUser', res.data)
    } catch(err) {
      commit('logoutUser')
      router.push('/join/login')
      console.log(err);
    }
  },
  async registerUser ({ commit }, data) {
    try{
      const res = await authService.register(data.firstname, data.email, data.password, data.type);
      console.log(res)
      commit('ChangeUser', res.data.user)
      commit('AuthUser', {bool:true, token:res.data.token})
      window.location.href = "/"
    } catch(err) {
      console.log(err);
      EventBus.$emit('systemNotification', 'Something went wrong 🤔')
    }
  },
  async inviteUser ({ commit }, data) {
    try{
      const res = await authService.invite(data.email, data.type);
      console.log(res)
      commit('')
      EventBus.$emit('systemNotification', 'Invited '+data.email)
      window.location.href = "/"
    } catch(err) {
      console.log(err);
      EventBus.$emit('systemNotification', 'Something went wrong 🤔')
    }
  },
  async loginUser ({ commit }, userInputs) {
    try{
      const res = await authService.login(userInputs.email, userInputs.password);
      commit('ChangeUser', res.data.user)
      commit('AuthUser', {bool:true, token:res.data.token})
      window.location.href = "/"
    } catch(err) {
      console.log(err);
      EventBus.$emit('systemNotification', 'Something went wrong 🤔')
    }
  },
  async updateUser ({ commit }, userInputs) {
    try{
      const res = await authService.update(
        userInputs.firstname, 
        userInputs.lastname,
        userInputs.phonenumber,
        userInputs.email
      );
      commit('ChangeUser', res.data.user)
      EventBus.$emit('systemNotification', 'Updated user')
    } catch(err) {
      console.log(err)
      EventBus.$emit('systemNotification', 'Something went wrong 🤔')
    }
  },
  async logoutUser({ commit }){
    try{
      commit('logoutUser');
      router.push('/join/login')
      EventBus.$emit('systemNotification', 'See you soon ;)')
    } catch(err) {
      console.log(err);
      EventBus.$emit('systemNotification', 'Something went wrong 🤔')
    }
  },
  async requestPassword({ commit },userInputs){
    try{
      await authService.requestPassword(userInputs.email);
      router.push('/join/login')
      EventBus.$emit('systemNotification', 'Request email is send')
    } catch(err) {
      EventBus.$emit('systemNotification', 'Something went wrong 🤔')
      console.log(err);
      console.log(commit)
    }
  },
  async resetPassword({ commit },userInputs){
    try{
      await authService.resetPassword(userInputs.resetToken, userInputs.password);
      router.push('/join/login')
      EventBus.$emit('systemNotification', 'Reset succesfull')
    } catch(err) {
      console.log(commit)
      console.log(err);
      EventBus.$emit('systemNotification', 'Something went wrong 🤔')
    }
  },
  async inviteRegister({ commit },userInputs){
    try{
      await authService.inviteRegister(
        userInputs.invitationToken, 
        userInputs.password,
        userInputs.phone,
        userInputs.firstname,
        userInputs.lastname,
        );
      router.push('/join/login')
      EventBus.$emit('systemNotification', 'Please log in to your account')
    } catch(err) {
      console.log(commit)
      console.log(err);
      EventBus.$emit('systemNotification', 'Something went wrong 🤔')
    }
  }
}

const mutations = {
  ChangeUser (state, data) {
    state.firstname = data.firstname;
    state.lastname = data.lastname;
    state.phonenumber = data.phonenumber;
    state.email = data.email;
    state.type = data.type;
    state.id = data._id; // Add this line to include the ID property
  },
  AuthUser (state, {bool, token}){
    state.isAuthenticated = bool;
    if (token) jwtService.saveToken(token);
  },
  async logoutUser (state) {
    try{
      await authService.logout();
      state.firstname = '';
      state.lastname = '';
      state.phonenumber = '';
      state.type = ''
      state.email = '';
      state.isAuthenticated = false;
      jwtService.saveToken('');
    } catch(err) {
      console.log(err);
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}